import Vue from "vue";

export function hasWalkInContent(options) {
  return new Promise((resolve, reject) => {
    Vue.onesocket.send({
      function: "hasWalkInContent",
      module: "SQMOD_Auth",
      data: { ...options },
      onMessage: function (data) {
        resolve(data.payload.root);
      },
      onError: function (error) {
        reject(error);
        Vue.logger.error("api-auth", "Failed to fetch walkin content", error);
      },
    });
  });
}
